import { render, staticRenderFns } from "./IncomeProofsControl.vue?vue&type=template&id=007cfb0f&"
import script from "./IncomeProofsControl.vue?vue&type=script&lang=js&"
export * from "./IncomeProofsControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports